function waitForElm(selector, doc = document) {
    return new Promise(resolve => {
        if (doc.querySelector(selector)) {
            return resolve(doc.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (doc.querySelector(selector)) {
                resolve(doc.querySelector(selector));
                observer.disconnect();
            }
        });

        observer.observe(doc, {
            childList: true,
            subtree: true
        });
    });
}